import { Button } from "antd";
import { useTranslation } from "react-i18next";

const CustomNavigationFooter = ({ handleCloseModal, form, onNextClick, nextButtonDisable }) => {

    const { t } = useTranslation();

    return <div style={{ textAlign: 'right', marginTop: '20px' }}>
        <Button type="primary" onClick={() => { handleCloseModal(); form.resetFields(); }}>
            {t("Close")}
        </Button>
        <Button type="primary" onClick={onNextClick} disabled={nextButtonDisable}>
            {t("Next")}
        </Button>
    </div>
}

export default CustomNavigationFooter;